import React, {Component} from 'react'
import PropTypes from 'prop-types'

class SortNumber extends Component {
    render() {
        const {limit, page, index} = this.props

        return (
            <td className="SortNumber">
                {(limit * (page - 1)) + (index + 1)}
            </td>
        )
    }
}

SortNumber.propTypes = {
    limit: PropTypes.number,
    page: PropTypes.number,
    index: PropTypes.number
}

export default SortNumber